import Swiper, {Navigation} from 'swiper';

const homeSlider = new Swiper(".home-slider", {
    modules: [Navigation],
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});
const aboutSlider = new Swiper(".about-slider", {
    slidesPerView: 3,
    autoplay: true,
    spaceBetween: 10,
    loop: true,
});

const productinfoOffersSlider = new Swiper(".product-info-offers-slider", {
    modules: [Navigation],
    slidesPerView: 1,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        320: {
            slidesPerView: 2,
        },
        920: {
            slidesPerView: 4,
        },
    }
});

const profile_sales = new Swiper(".profile-sales", {
    modules: [Navigation],
    autoplay: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

// document.addEventListener('DOMContentLoaded', () => {
//     // window.onload = () => {
//     const swiper = new Swiper(".mySwiper", {
//         spaceBetween: 10,
//         slidesPerView: 4,
//         freeMode: true,
//         watchSlidesProgress: true,
//     });
//     const swiper2 = new Swiper(".mySwiper2", {
//         modules: [Navigation, Thumbs],
//         spaceBetween: 10,
//         navigation: {
//             nextEl: ".swiper-button-next",
//             prevEl: ".swiper-button-prev",
//         },
//         thumbs: {
//             swiper: swiper,
//         },
//     });
//     // }
// });
